import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import zhCN from 'antd/lib/locale/zh_CN';
import { ConfigProvider } from 'antd';
import reportWebVitals from './reportWebVitals';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import storageUtils from '@/utils/storageUtils';
import config from '@/config/config';

let token = JSON.parse(storageUtils.get(config.loginStorageKey));
let userInfo = {}; // 用于存放用户信息 store
if (token && token.loginInfo && token.loginInfo.userInfo) { // 从localStorage 查找用户信息
  userInfo = token.loginInfo.userInfo;
}
const reducer = (state = userInfo, action) => {
  switch (action.type) {
    case 'change':
      state = action.value
      return Object.assign({}, state); // 必须返回新的state 不然不会重新渲染
    default:
      return state;
  }
}
const store = createStore(reducer);

//连接组件
// App = connect(mapStateToProps, mapDispatchToProps)(App)
ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
